import api from "./api";

// Filiales: listado para el mantenimiento y lista corta para los filtros.

export const getsFilial = async () => {
    const response = await api.get("/Filial/GetsFilial");

    return response.data.data;
}

export const getFilialById = async (idFilial) => {
    const response = await api.get("/Filial/GetFilialById", { params: { idFilial } });

    return response.data.data;
}

export const getFilialesList = async () => {
    const response = await api.get("/Filial/GetsList");

    return response.data.data;
}

export const getsFiliales = getFilialesList;

// Los filiales que el usuario puede ver en un filtro: si tiene filial
// asignada, solo esa; si no (idFilial 0), todas. Lo usan las ventanas de
// navegabilidad que filtran por filial.
export const soloFilialDelUsuario = (lista, idFilial) => {
    if (!idFilial || idFilial <= 0) return lista || [];

    return (lista || []).filter((filial) => filial.id === idFilial);
}

export const addUpdateFilial = async (dataPost) => {
    const response = await api.post("/Filial/AddUpdateFilial", dataPost);

    return response.data.data;
}

export const annulFilial = (idFilial) =>
    api.post("/Filial/AnnulFilial?idFilial=" + idFilial);

export const activeFilial = (idFilial) =>
    api.post("/Filial/ActiveFilial?idFilial=" + idFilial);

export default {
    getsFilial,
    getFilialById,
    getFilialesList,
    getsFiliales,
    soloFilialDelUsuario,
    addUpdateFilial,
    annulFilial,
    activeFilial,
};